<div class="modal">
    <div class="header">
        <h1 class="title">{{'PREMIUM_TEAM_MEMBER_MODAL_ADD_MEMBER_TITLE' | translate}}</h1>
    </div>
    <div class="body">
        <ng-container *ngIf="(memberCreationPending$ | async); else memberCreationNotPending">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #memberCreationNotPending>
            <div class="section">
                <form class="form-section" [formGroup]="memberCreationForm" (ngSubmit)='onSubmit()'>
                    <!-- <div class="section"> -->
                        <h2 class="title-section">{{ 'PREMIUM_TEAM_MEMBER_MODAL_ADD_MEMBER_SUBTITLE_INFORMATIONS' | translate }}</h2>
                        <div class="form-input">
                            <ng-select [attr.invalid]="(memberCreationError$ | async)?.code === 409 ? '' : null" (click)="$event.stopPropagation()" [items]="attachableMembers" bindLabel="username" [searchable]="true"
                                [clearable]="true" [addTag]="addEmail"
                                placeholder="{{ 'PREMIUM_TEAM_MEMBER_MODAl_ATTACH_MEMBER_TO_GROUP_PLACEHOLDER_MEMBER' | translate }}"
                                formControlName="member" [(ngModel)]="selectedMember" (change)="onSelectMemberChange($event)">
                                <ng-template ng-tag-tmp let-search="searchTerm">
                                    <b>{{'PREMIUM_TEAM_MEMBER_MODAL_TAG_ADD_EMAIL' | translate}}</b> : {{search}}
                                </ng-template>
                            </ng-select>
                            <div *ngIf="(memberCreationError$ | async)?.code === 409" class="error"
                                [translateParams]="{email : (memberCreationError$ | async)?.details.primary }" translate>
                                PREMIUM_ADMIN_MEMBER_MODAL_ERROR_USER_ALREADY_EXISTS
                            </div>
                        </div>
                        <ng-container *ngIf="selectedMember && !selectedMember?.id">
                            <div class="form-input">
                                <app-smash-input type="text" borderStyle="full"
                                    placeholder="{{ 'PREMIUM_TEAM_MEMBER_MODAL_ADD_MEMBER_PLACEHOLDER_LASTNAME' | translate }}" formControlName="lastName"
                                    [error]='submitted && f.lastName.errors'>
                                </app-smash-input>
                            </div>
                            <div class="form-input">
                                <app-smash-input type="text" borderStyle="full"
                                    placeholder="{{ 'PREMIUM_TEAM_MEMBER_MODAL_ADD_MEMBER_PLACEHOLDER_FIRSTNAME' | translate }}"
                                    formControlName="firstName" [error]='submitted && f.firstName.errors'>
                                </app-smash-input>
                            </div>
                            <div class="form-input">
                                <ng-select [items]="authenticationModes" bindValue="value" [searchable]="false" [clearable]="false"
                                    placeholder="{{ 'PREMIUM_TEAM_MEMBER_MODAL_ADD_MEMBER_PLACEHOLDER_AUTHENTICATION_MODE' | translate }}"
                                    formControlName="authenticationMode" [(ngModel)]="selectedAuthenticationMode">
                                    <ng-template ng-label-tmp let-item="item">
                                        {{ item.translation | translate }}
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item">
                                        {{ item.translation | translate }}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </ng-container>
                    <!-- </div> -->
                    <!-- <div class="section"> -->
                        <div class="invite-container" *ngIf="f.authenticationMode?.value === 'Standard'">
                            <app-smash-checkbox [value]="isInvited" [(ngModel)]="isInvited" formControlName="invited"></app-smash-checkbox>
                            <label class="invite-label">{{ 'PREMIUM_TEAM_MEMBER_MODAL_ADD_MEMBER_PLACEHOLDER_SEND_INVITE' | translate }}</label>
                        </div>
                    <!-- </div> -->
                    <!-- <div class="section"> -->
                        <h2 class="title-section">{{ 'PREMIUM_TEAM_MEMBER_MODAL_ADD_MEMBER_SUBTITLE_ROLE' | translate }}</h2>
                        <div class="form-input" *ngIf="teamRoles?.length">
                            <ng-select [items]="teamRoles" bindLabel="name" [searchable]="false" [clearable]="true"
                                placeholder="{{ 'PREMIUM_TEAM_MEMBER_MODAL_ADD_MEMBER_PLACEHOLDER_ROLE' | translate }}" formControlName="role"
                                [(ngModel)]="selectedRole">
                                <ng-template ng-label-tmp let-item="item">
                                    {{item?.name?.split('$')[1].toUpperCase() | translate}}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    {{item?.name?.split('$')[1].toUpperCase() | translate}}
                                </ng-template>
                            </ng-select>
                        </div>
                    <!-- </div> -->
                </form>
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="closeModal()" [disabled]="(memberCreationPending$ | async)"
            translate>PREMIUM_TEAM_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_CANCEL</button>
        <button class="btn-new red" type="submit" (click)="onSubmit()"
            [disabled]="!memberCreationForm.valid || (memberCreationPending$ | async)"
            translate>PREMIUM_TEAM_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_CREATE_MEMBER</button>
    </div>
</div>